import { hotkeys } from 'react-keyboard-shortcuts';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import withWidth from '@material-ui/core/withWidth';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import InfoIcon from '@material-ui/icons/Info';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ENTITLEMENTS } from '../application-core/constants';
import GetStarted from '../application-core/GetStarted';
import ActionText from '../core/ActionText';
import CreateButton from '../core/CreateButton';
import ProjectLanguageSelector from '../core/ProjectLanguageSelector';
import { globalStyles } from '../core/style/gstheme';
import { PANEL_WIDTH_NORMAL, PANEL_WIDTH_WIDE } from '../core/utils/constants';
import { checkResourceEntitlements } from '../core/utils/utils';
import withGS from '../core/withGShoc';
import CreateNodeDialogContainer from './CreateNodeDialogContainer';
import CreateResourceDialog from './CreateResourceDialog';
import PropertyData from './PropertyData';
import ResourceSearch from './ResourceSearch';
import ResourceStructure from './ResourceStructure';

const styles = Object.assign({}, globalStyles);

function PropertyCreateDialog(props) {

  const childExclusions = props.data[props.childProperty] ? props.data[props.childProperty] : [];

  return (
    <CreateNodeDialogContainer
      ontologyIRI={props.ontologyIRI}
      useSlashIRI={props.useSlashIRI}
      useUuidIRI={props.useUuidIRI}
      iriOptions={props.iriOptions}
      button={props.bigButton ? <CreateButton label="Add" /> : null}
      parentIRI={props.data.id}
      graph={props.graph}
      useWorkflow={props.useWorkflow}
      onlyComponentResources={true}
      onAddExistingNode={props.onAddExistingNode}
      onAddNewNode={props.onAddNewNode(props.titlePath, "")}
      disableMultiple={props.disableMultiple}
      searchClass={props.searchClass}
      searchClassFilter={[
        "http://www.w3.org/2002/07/owl#Class",
        "http://www.w3.org/2002/07/owl#AnnotationProperty",
        "http://www.w3.org/2002/07/owl#DatatypeProperty",
        "http://www.w3.org/2002/07/owl#ObjectProperty",
        "http://www.w3.org/2002/07/owl#NamedIndividual",
        "http://www.w3.org/2000/01/rdf-schema#Datatype"
      ]}
      exclude={[
        ...childExclusions,
        "https://graphifi.com/schema/xowl/topAnnotationProperty",
        "http://www.w3.org/2002/07/owl#topObjectProperty",
        "http://www.w3.org/2002/07/owl#topDataProperty",
        "http://www.w3.org/2002/07/owl#Thing"
      ]}
      createDialog={CreateResourceDialog}
      title="Add Property"
      placeholder="Enter property label"
      name="Add a top property (Alt+n)"
    />
  );
}

class PropertyView extends Component {

  constructor(props) {
    super(props);
    this.infoRef = React.createRef();
    this.controlRef = React.createRef();
  }

  hot_keys = {
    'alt+i': {
      priority: 1,
      handler: () => {
        if (this.infoRef && this.infoRef.current) {
          this.infoRef.current.focus();
        }
      }
    },
    'alt+c': {
      priority: 1,
      handler: () => {
        if (this.controlRef && this.controlRef.current) {
          this.controlRef.current.focus();
        }
      }
    }
  };

  componentDidMount() {
    if (this.props.activeProperty && this.props.data[this.props.childProperty])
      this.props.onFoundProperty(this.props.data[this.props.childProperty])(this.props.activeProperty);
  }

  excludeByPathFunction = (id) => {
    const ebp = [];
    ebp.push({
      predicate: [
        "http://www.w3.org/2000/01/rdf-schema#subPropertyOf"
      ],
      target: id,
      reverse: true
    });
    ebp.push({
      predicate: [
        "https://graphifi.com/schema/xowl/hasSubProperty"
      ],
      target: id,
      reverse: true
    });
    if (this.props.childProperty === "subPropertyOf") {
      ebp.push({
        predicate: [
          "http://www.w3.org/2000/01/rdf-schema#subPropertyOf"
        ],
        target: id,
        pathOperators: ["+"]
      });
    }
    if (this.props.childProperty === "hasSubProperty") {
      ebp.push({
        predicate: [
          "https://graphifi.com/schema/xowl/hasSubProperty"
        ],
        target: id,
        pathOperators: ["+"]
      });
    }
    return ebp;
  };

  render() {

    const { activeProperty, classes, ontologyIRI, onSelect, onAddNewNode, expandNode, collapseNode, selectedTitlePath, onAddExistingNode,
      data, appBar, foundRef, defaultLang, foundPath, onFoundProperty, childProperty, searchClass, buildLink, titlePath, viewLang, hiddenProps,
      viewWidth, width, onFullViewChange, onViewWidthChange, isFullView, editingOptions,
      onCollapse, availableAnnotationProperty, useSlashIRI, useUuidIRI, advancedView, entitlements, projectUsers, useWorkflow,
      foundTime, onDeleteNode, expandedPaths, project, onBreakLink, graph, onSelectViewLanguage, iriOptions, excludeDeprecated } = this.props;

    const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_ONTOLOGY);
    const isLargeScreen = width === "lg" || width === "xl";
    const panelWidth = advancedView ? PANEL_WIDTH_WIDE : PANEL_WIDTH_NORMAL;

    return (
      <div>
        <div className={classes.controlPanel}
          style={{
            ...(!isFullView && advancedView && viewWidth === 0) && { width: panelWidth },
            ...(isFullView) && { width: 'calc(100% - 100px)' },
            ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (panelWidth + (viewWidth * 100)) }
          }}>
          <div className={classes.views}>
            {appBar}
          </div>
          <div className={classes.controlPanelInner}>
            <div className={classes.controlPanelAdd}>
              {!isReadOnly && data[childProperty] && data[childProperty].length > 0 ?
                <CreateNodeDialogContainer
                  ontologyIRI={ontologyIRI}
                  useSlashIRI={useSlashIRI}
                  useUuidIRI={useUuidIRI}
                  parentIRI={data.id}
                  graph={graph}
                  useWorkflow={useWorkflow}
                  onlyComponentResources={true}
                  iriOptions={iriOptions}
                  onAddExistingNode={onAddExistingNode}
                  onAddNewNode={onAddNewNode(titlePath, "")}
                  searchClass={searchClass}
                  searchClassFilter={[
                    "http://www.w3.org/2002/07/owl#Class",
                    "http://www.w3.org/2002/07/owl#AnnotationProperty",
                    "http://www.w3.org/2002/07/owl#DatatypeProperty",
                    "http://www.w3.org/2002/07/owl#ObjectProperty",
                    "http://www.w3.org/2002/07/owl#NamedIndividual",
                    "http://www.w3.org/2000/01/rdf-schema#Datatype"
                  ]}
                  createDialog={CreateResourceDialog}
                  existing={data[childProperty]}
                  exclude={
                    [
                      "https://graphifi.com/schema/xowl/topAnnotationProperty",
                      "http://www.w3.org/2002/07/owl#topObjectProperty",
                      "http://www.w3.org/2002/07/owl#topDataProperty",
                      "http://www.w3.org/2002/07/owl#Thing"
                    ]}
                  title="Add Property"
                  placeholder="Enter property label"
                  name="Add a top property (Alt+n)"
                />
                :
                <span style={{ width: 30 }}>&nbsp;</span>
              }
            </div>
            <div className={advancedView ? classes.controlPanelSearchWide : classes.controlPanelSearch}>
              {data[childProperty] && data[childProperty].length > 0 &&
                <ResourceSearch
                  searchClass={searchClass}
                  graph={graph}
                  title="Find a property"
                  ontologyIRI={ontologyIRI}
                  onFoundResource={onFoundProperty(data[childProperty])}
                  defaultLang={viewLang || defaultLang} />
              }
            </div>
          </div>
          <div data-test="property-tree" tabIndex={0} ref={this.controlRef}
            className={classes.deepTree}
            style={
              {
                ...(advancedView && viewWidth === 0) && { width: panelWidth },
                ...(isFullView) && { width: 'calc(100% - 100px)' },
                ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (panelWidth + (viewWidth * 100)) }
              }
            }>
            {data[childProperty] && data[childProperty].length > 0 &&
              <div className={advancedView ? classes.treeOptionsWide : classes.treeOptions}>
                <div data-test="editing-mode" style={{ paddingTop: 4, paddingBottom: 4, overflow: 'auto' }}>
                  {excludeDeprecated &&
                    <Tooltip title={<span data-test="deprecated-message">{"Deprecated properties are hidden"}</span>}>
                      <span data-test={"deprecated-hidden"} onClick={onCollapse} style={{ float: 'right', marginLeft: 4, color: '#CA4F0C' }}>
                        <InfoIcon style={{ transform: 'translateY(3px)' }} />
                      </span>
                    </Tooltip>
                  }
                  <Tooltip title="Collapse all">
                    <span data-test={"collapse-all"} onClick={onCollapse} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-collapse-all"} size="small">
                        <UnfoldLessIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Toggle full view mode">
                    <span data-test={"full-view"} onClick={onFullViewChange} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-full-view"} size="small">
                        {isFullView ?
                          <FullscreenExitIcon />
                          :
                          <FullscreenIcon />
                        }
                      </IconButton>
                    </span>
                  </Tooltip>
                  {isLargeScreen &&
                    <Tooltip title="Change hierarchy width">
                      <span data-test={"split-view-" + viewWidth} onClick={onViewWidthChange} style={{ float: 'right' }}>
                        <IconButton data-test={"option-split"} size="small">
                          <VerticalSplitIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  }
                </div>
              </div>
            }
            {data[childProperty] && data[childProperty].length > 0 ?
              <ResourceStructure
                filter={true}
                isReadOnly={isReadOnly}
                useWorkflow={useWorkflow}
                defaultLang={defaultLang}
                foundPath={foundPath}
                foundRef={foundRef}
                buildLink={buildLink}
                graph={graph}
                iriOptions={iriOptions}
                activeResource={activeProperty}
                onBreakLink={onBreakLink}
                titlePath={titlePath}
                titleTree={[]}
                excludeDeprecated={excludeDeprecated}
                viewLang={viewLang}
                selectedTitlePath={selectedTitlePath}
                foundTime={foundTime}
                childProperty={childProperty}
                expandedPaths={expandedPaths}
                onAddExistingNode={onAddExistingNode}
                onAddNewNode={onAddNewNode && searchClass !== "http://www.w3.org/2002/07/owl#AnnotationProperty" ? onAddNewNode : null}
                onDeleteNode={onDeleteNode}
                expandNode={expandNode}
                collapseNode={collapseNode}
                ontologyIRI={ontologyIRI}
                useSlashIRI={useSlashIRI}
                useUuidIRI={useUuidIRI}
                data={data}
                path=""
                onSelect={onSelect}
                searchClass={searchClass}
                excludeByPath={this.excludeByPathFunction}
                searchClassFilter={[
                  "http://www.w3.org/2002/07/owl#Class",
                  "http://www.w3.org/2002/07/owl#DatatypeProperty",
                  "http://www.w3.org/2002/07/owl#AnnotationProperty",
                  "http://www.w3.org/2002/07/owl#ObjectProperty",
                  "http://www.w3.org/2002/07/owl#NamedIndividual"
                ]}
                permissions={[ENTITLEMENTS.EDIT_ONTOLOGY]}
                createDialog={CreateResourceDialog}
                addTitle="Add Subproperty"
                emptyLevel="No properties."
              />
              :
              isReadOnly ?
                <ActionText offset="85px">No properties.</ActionText>
                :
                <GetStarted text="Add a property to get started." action={
                  <PropertyCreateDialog bigButton={true} disableMultiple={true} {...this.props} />
                } />
            }
          </div>
        </div>
        <div data-test="language-panel" className={classes.viewLanguagePanel}>
          <ProjectLanguageSelector selectedLang={viewLang} includeLabel={false} onSelect={onSelectViewLanguage} />
        </div>
        {!isFullView &&
          <div data-test="info-panel" ref={this.infoRef} tabIndex={0}
            className={classes.infoPanel}
            style={
              {
                ...(!isFullView && viewWidth === 0) && { left: panelWidth + 40 },
                ...(!isFullView && viewWidth !== 0) && { left: ((panelWidth + 40) + (viewWidth * 100)) }
              }
            }>
            {
              data[childProperty] && data[childProperty].length > 0 ?
                (
                  activeProperty === null ?
                    <ActionText offset="180px">Select a property to view the detail.</ActionText>
                    :
                    <PropertyData
                      key={activeProperty}
                      project={project}
                      availableAnnotationProperty={availableAnnotationProperty}
                      entitlements={entitlements}
                      projectUsers={projectUsers}
                      useWorkflow={useWorkflow}
                      graph={graph}
                      hiddenProps={hiddenProps}
                      excludeDeprecated={excludeDeprecated}
                      viewLang={viewLang}
                      buildLink={buildLink}
                      editingOptions={editingOptions}
                      searchClass={searchClass}
                      propertyIRI={activeProperty}
                      ontologyIRI={ontologyIRI}
                      onDeleteProperty={onDeleteNode} />
                )
                :
                <ActionText offset="180px">When properties are created you will be able to view the detail here.</ActionText>
            }
          </div>
        }
      </div>
    );
  }
}

PropertyView.defaultProps = {
  viewWidth: 0
};

PropertyView.propTypes = {
  classes: PropTypes.object,
  entitlements: PropTypes.array.isRequired,
  projectUsers: PropTypes.array,
  buildLink: PropTypes.func.isRequired,
  defaultLang: PropTypes.string.isRequired,
  searchClass: PropTypes.string.isRequired,
  ontologyIRI: PropTypes.string.isRequired,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  activeProperty: PropTypes.string,
  graph: PropTypes.string.isRequired,
  titlePath: PropTypes.array.isRequired,
  childProperty: PropTypes.string.isRequired,
  selectedTitlePath: PropTypes.array,
  expandNode: PropTypes.func.isRequired,
  collapseNode: PropTypes.func.isRequired,
  onAddExistingNode: PropTypes.func.isRequired,
  onAddNewNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired,
  onFoundProperty: PropTypes.func.isRequired,
  excludeDeprecated: PropTypes.bool,
  viewLang: PropTypes.string,
  onBreakLink: PropTypes.func.isRequired,
  foundPath: PropTypes.string,
  onSelectViewLanguage: PropTypes.func,
  foundTime: PropTypes.number,
  foundRef: PropTypes.object,
  project: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isFullView: PropTypes.bool,
  viewWidth: PropTypes.number,
  onCollapse: PropTypes.func,
  useWorkflow: PropTypes.bool,
  onFullViewChange: PropTypes.func.isRequired,
  onViewWidthChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  availableAnnotationProperty: PropTypes.array,
  hiddenProps: PropTypes.array,
  iriOptions: PropTypes.object,
  editingOptions: PropTypes.array
};

export default withWidth()(withStyles(styles)(withGS(hotkeys(PropertyView))));